import './../../stylesheets/activity_fields';

// 全選択ボタン
export function fieldAllSelect () {
  let target = document.getElementById('field_all_select');
  if (!!target) {
    target.addEventListener('click', function(event) {
      let checkboxes = this.closest('.row').querySelectorAll('input[type="checkbox"]');
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = true;
      }
    });
  }
}

// 全解除ボタン
export function fieldAllRelease () {
  let target = document.getElementById('field_all_release');
  if (!!target) {
    target.addEventListener('click', function(event) {
      let checkboxes = this.closest('.row').querySelectorAll('input[type="checkbox"]');
      for (let i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = false;
      }
    });
  }
}

// チェックボックスの選択サポート
export function fieldCustom () {
  let targets = document.querySelectorAll('.activity-field-item');
  for (let i = 0; i < targets.length; i++) {
    if (!!targets[i]) {
      targets[i].addEventListener('click', function(event) {
        if (event.target == this) {
          this.querySelector('input[type="checkbox"]').click();
        }
      });
    }
  }
}